import React from "react";

export const HALF_STAR_ID = "half-star-gradient";
export const LMN_HALF_STAR_ID = "lmn-half-star-gradient";

const StarGradient = () => {
  return (
    <svg style={{ width: 0, height: 0, position: "absolute" }}>
      <defs>
        <linearGradient id="star-gradient">
          <stop offset="0%" stopColor="#CCBB66"/>
          <stop offset="50%" stopColor="#CCBB66"/>
          <stop offset="50%" stopColor="#DCDCDF"/>
          <stop offset="100%" stopColor="#DCDCDF"/>
        </linearGradient>
        <linearGradient
          id={ HALF_STAR_ID }
          xlinkHref={"#star-gradient"}
          spreadMethod="repeat"/>

        <linearGradient id="lmn-star-gradient">
          <stop offset="0%" stopColor="#FFB700"/>
          <stop offset="50%" stopColor="#FFB700"/>
          <stop offset="50%" stopColor="#DCDCDF"/>
          <stop offset="100%" stopColor="#DCDCDF"/>
        </linearGradient>
        <linearGradient
          id={ LMN_HALF_STAR_ID }
          xlinkHref={"#lmn-star-gradient"}
          spreadMethod="repeat"/>
      </defs>
    </svg>
  );
};


export default StarGradient;
